'use strict';

var MAX_NOTIFICATIONS = 50;

require('../user/CurrentUserService.js');
require('../auth/AuthService.js');
require("../app/UploadTracker.js");
require('../company/CompanyService.js');
require('../company/notifications/CompanyNotificationsService.js');

function RootCtrl(
  $rootScope,
  $scope,
  $state,
  $timeout,
  $window,
  currentUser,
  AuthService,
  companies,
  config,
  $document,
  CompanyService,
  CompanyNotificationsService,
  $translate) {
  $scope.companies = companies;
  $scope.currentUser = currentUser;
  $scope.logout = AuthService.logout;
  $scope.userMenuOpen = false;
  $scope.sidebarOpen = false;
  $scope.fileUploads = [];
  $scope.apiBase = config.apiBase;

  $scope.listPublications = function(companyId, userType) {
    CompanyService.get({
      companyId: companyId,
      enterCompany: true
    });

    var route; 

    switch (userType) {
      case 'GUEST':
        route = 'root.company-guest.publications';
        break;
      default:
        route = 'root.company.publications-list';
    }

    $state.go(route, {companyId: companyId});
  };

  $rootScope.notifications       = [];
  $rootScope.notificationsUnread = 0;

  $translate.use(angular.lowercase($scope.currentUser.language));
  $window.localStorage.language = $scope.currentUser.language;
  $scope.$on('languageChanged', function(event, data) {
    $translate.use(angular.lowercase(data));
    $window.localStorage.language = data;
  });

  function loadData(offset){
    if ($state.current.name === 'root.company-selection') {
      CompanyNotificationsService.queryNotificationsUser({userId: currentUser.id, offset: offset, limit: MAX_NOTIFICATIONS}, function(notificationsObject){
        $rootScope.notifications = $rootScope.notifications.concat(notificationsObject.notifications);
        $rootScope.notificationsUnread = notificationsObject.unView;
      });
    }
  }

  $scope.$on('$stateChangeSuccess', function(){
    loadData(0);
  });

  $scope.$on('notification', function() {
    $scope.$apply(function() {
      loadData(0);
    });
  });

  $scope.closeNotifications = function() {
    if (!$scope.preventBlur) {
      $scope.notificationsOpen = false;
    }

    $scope.preventBlur = false;
  };

  $scope.toggleNotificationsOpen = function(preventBlur) {
    $scope.notificationsOpen = $scope.notificationsOpen ? false : true;
    $scope.notificationLimit = MAX_NOTIFICATIONS;

    if (preventBlur) {
      $scope.preventBlur = true;
    }

    setTimeout(function(){
      if ($state.current.name === 'root.company-selection' && $rootScope.notificationsUnread > 0) {
        CompanyNotificationsService.updateNotificationsUser({userId: currentUser.id}, {}, function(){
          $rootScope.notificationsUnread = 0;
          angular.forEach($rootScope.notifications, function(notification){
            notification.viewed = true;
          });
        });
      }
    }, 5000);
  };

  $scope.loadMoreNotifications = function() {
    loadData($scope.notificationLimit + 1);
    $scope.notificationLimit = $scope.notificationLimit + MAX_NOTIFICATIONS;
  };

  $scope.markAsRead = function(notification, companyId) {
    notification.viewed = true;
    CompanyNotificationsService.update({companyId: companyId, notificationId: notification.id}, {viewed: true}, function(){
      $rootScope.notificationsUnread--;
    });
  };

  $scope.toggleSidebar = function() {
    $scope.sidebarOpen = !$scope.sidebarOpen;
  };

  $scope.closeSidebar = function() {
    $scope.sidebarOpen = false;
  };

  $scope.removeFileUpload = function(upload) {
    var idx = $scope.fileUploads.indexOf(upload);

    if(idx !== -1) {
      $scope.fileUploads[idx].abort();
      $scope.fileUploads.splice(idx, 1);
    }
  };

  $rootScope.$on("file-upload.start", function(event, upload) {
    $scope.fileUploads.push(upload);
  });

  $rootScope.$on("file-upload.complete", function(event, upload) {
    $timeout(function() {
      $scope.removeFileUpload(upload);
    }, 2000);
  });

}

RootCtrl.resolve = {
  currentUser: ['CurrentUserService', function(CurrentUserService) {
    return CurrentUserService.get();
  }],
  companies: ['CompanyService', function(CompanyService) {
    return CompanyService.query({limit: 100}).$promise;
  }]
};
module.exports = RootCtrl;

angular.module('dokiv')
  .controller('RootCtrl', [
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$window',
    'currentUser',
    'AuthService',
    'companies',
    'config',
    '$document',
    'CompanyService',
    'CompanyNotificationsService',
    '$translate', RootCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/RootCtrl.js
// module id = 250
// module chunks = 0